import { format } from "date-fns";

import { NOW } from "@/shared/models/legacy-constants";

export const formatXTick = (tick: string) => {
  const date = new Date(NOW.getFullYear(), Number(tick) - 1);
  return format(date, "MMM");
};
